import { CircularProgress } from "@mui/material";
import { useEffect, useState } from "react";
import { Navigate, Outlet, useLocation } from "react-router";
import { getFetcher } from "../Fetchers";
import { toast } from "react-toastify";
import { notifWarn } from "../Functions";

const ProtectedRoute = () => {
  const [isAuthenticated, setIsAuthenticated] = useState<boolean | null>(null);
  const location = useLocation();

  const checkAuthStatus = async () => {
    try {
      await getFetcher(`${process.env.REACT_APP_API_URL}/auth/verify`);
      return true;
    } catch (err) {
      toast.clearWaitingQueue();
      notifWarn("Uživatel není přihlášen.", 2000);
      setTimeout(() => {
        toast.clearWaitingQueue();
      }, 2000);
      return false;
    }
  };

  useEffect(() => {
    const verify = async () => {
      const authenticated = await checkAuthStatus();
      setIsAuthenticated(authenticated);
    };
    verify();
  }, [location]);

  if (isAuthenticated === null) {
    return <CircularProgress />;
  }

  if (!isAuthenticated) return <Navigate to="/login" />;

  return <Outlet />;
};

export default ProtectedRoute;
